import { useTranslation } from 'react-i18next';
import { ArrowLeft, ChevronRight, Crown } from 'lucide-react';

import { PreviewArt } from '../app/PreviewArt';

import '../../styles/pages/diet-import.css';

const ProTag = () => (
  <span className="mt-di-pro">
    <Crown aria-hidden="true" />
    Pro
  </span>
);

/**
 * How to get a diet plan: the AI's questionnaire first (the main way, one card that leads), then bringing in a plan
 * the person already has (a nutritionist's photo, PDF or text) or building one by hand. "Mudar meu plano" opens it
 * too, with the way back to the plan. Free accounts see all three with the Pro tag: the questionnaire still opens
 * (its numbers are free), the other two open behind the Pro card.
 */
export const DietStart = ({ hasPlan, isPro, onAi, onImport, onManual, onBack }) => {
  const { t } = useTranslation();
  const ix = (key, options) => t(`pages.DietImport.${key}`, options);

  return (
    <div className="mt-di">
      {hasPlan && (
        <div className="mt-di-bar">
          <button type="button" className="mt-di-bar__back" onClick={onBack}>
            <ArrowLeft aria-hidden="true" />
            <span>{t('pages.DietPlan.ui.backToPlan')}</span>
          </button>
        </div>
      )}
      <div className="mt-di-head">
        <div>
          <h1 className="mt-di-head__title">{hasPlan ? ix('startChangeTitle') : t('pages.DietPlan.ui.title')}</h1>
          <p className="mt-di-head__sub">{hasPlan ? ix('startChangeSub') : ix('startSub')}</p>
        </div>
      </div>

      <div className="mt-di-start">
        <section className="mt-di-start__ai" aria-labelledby="mt-di-start-ai">
          <div className="mt-di-start__ai-head">
            <PreviewArt kind="rings" size="lg" />
            <h2 id="mt-di-start-ai" className="mt-di-start__ai-title">
              {ix('startAiTitle')}
              {!isPro && <ProTag />}
            </h2>
          </div>
          <p className="mt-di-start__ai-text">{ix('startAiText')}</p>
          <ul className="mt-di-start__points">
            <li>{ix('startAiPoint1')}</li>
            <li>{ix('startAiPoint2')}</li>
            <li>{ix('startAiPoint3')}</li>
          </ul>
          <button type="button" className="mt-btn mt-btn--primary mt-di-start__cta" onClick={onAi}>
            {ix('startAiButton')}
          </button>
        </section>

        <div className="mt-di-start__others">
          <p className="mt-di-start__or">{ix('startOr')}</p>
          <button type="button" className="mt-di-start__option" onClick={onImport}>
            <PreviewArt kind="sheet" />
            <span className="mt-di-start__option-text">
              <span className="mt-di-start__option-title">
                {ix('startImportTitle')}
                {!isPro && <ProTag />}
              </span>
              <span className="mt-di-start__option-desc">{ix('startImportText')}</span>
            </span>
            <ChevronRight className="mt-di-start__chevron" aria-hidden="true" />
          </button>
          <button type="button" className="mt-di-start__option" onClick={onManual}>
            <PreviewArt kind="rows" />
            <span className="mt-di-start__option-text">
              <span className="mt-di-start__option-title">
                {ix('startManualTitle')}
                {!isPro && <ProTag />}
              </span>
              <span className="mt-di-start__option-desc">{ix('startManualText')}</span>
            </span>
            <ChevronRight className="mt-di-start__chevron" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};
